import { useState } from 'react'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import { SUBSCRIBE_EMAIL_TO_NEWSLETTER } from './graphql/subscribeEmailToNewsletter'
import { SubscribeEmailToNewsletterOutput } from '@pylot-data/fwrdschema'
import { useRouter } from 'next/router'

export interface SubscribeInputVariables {
    email: string
}

export interface SubscribeOutputInterface {
    subscribeEmailToNewsletter: SubscribeEmailToNewsletterOutput
}

export interface UseSubscribeEmailToInterface {
    subscribeEmailNewsletter: (
        formInput: SubscribeInputVariables
    ) => Promise<GraphqlFetchOutput<SubscribeOutputInterface>>
    isLoading: boolean
}

export const useSubscribeEmailToNewsletter = (): UseSubscribeEmailToInterface => {
    const { locale } = useRouter()
    const [isLoading, setIsLoading] = useState(false)

    const subscribeEmailNewsletter = async (
        formInput: SubscribeInputVariables
    ) => {
        const { email } = formInput
        setIsLoading(true)

        const response = await graphqlFetch<
            SubscribeInputVariables,
            SubscribeOutputInterface
        >({
            query: SUBSCRIBE_EMAIL_TO_NEWSLETTER,
            variables: { email },
            locale
        })

        setIsLoading(false)
        return response
    }

    return {
        isLoading,
        subscribeEmailNewsletter
    }
}
